<template>
  <div>
    <sbpps-lc v-if="tenant == 'sbpps'" />
    <zeal-lc v-else-if="tenant == 'zeal'" />
    <veis-lc v-else-if="tenant == 'veis'" />
    <wws-lc v-else-if="tenant == 'wws'" />
    <vvp-lc v-else-if="tenant == 'vvp'" />
    <eps-lc v-else-if="tenant == 'eps'" />
    <sanjivani-lc v-else-if="tenant == 'sanjivani'" />

    <div v-else>Under Development.....</div>
  </div>
</template>

<script>
import zeallc from "./GetLeavingCertZeal.vue";
import sbppslc from "./GetLeavingCertSbpps.vue";
import veislc from "./GetLeavingCertVEIS.vue";
import wwslc from "./GetLeavingCertWWS.vue";
import vvplc from "./GetLeavingCertVVP.vue";
import epslc from "./GetLeavingCertEPS.vue";
import sanjivanilc from "./GetLeavingCertSanjivani.vue";

export default {
  components: {
    "zeal-lc": zeallc,
    "sbpps-lc": sbppslc,
    "veis-lc": veislc,
    "wws-lc": wwslc,
    "vvp-lc": vvplc,
    "eps-lc": epslc,
    "sanjivani-lc":sanjivanilc,
  },
  data: () => ({
    tenant: null,
  }),
  created() {
    this.tenant = localStorage.getItem("EPS-tenant");
    console.log("tenant:",this.tenant)
  },
};
</script>

<style>
</style>